import { useEffect } from 'react';

function ensureMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  return el;
}

function ensureLinkRel(rel) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  return el;
}

const Seo = ({
  title,
  description,
  url,
  image = '/image.png',
  type = 'website',
  siteName = 'Aluu Satuu',
  structuredData = null
}) => {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      const desc = ensureMeta('meta[name="description"]', { name: 'description' });
      desc.setAttribute('content', description);
    }

    if (url) {
      const canonical = ensureLinkRel('canonical');
      canonical.setAttribute('href', url);
    }

    // Open Graph
    const ogTitle = ensureMeta('meta[property="og:title"]', { property: 'og:title' });
    ogTitle.setAttribute('content', title || document.title);

    const ogDesc = ensureMeta('meta[property="og:description"]', { property: 'og:description' });
    ogDesc.setAttribute('content', description || '');

    const ogType = ensureMeta('meta[property="og:type"]', { property: 'og:type' });
    ogType.setAttribute('content', type);

    const ogSite = ensureMeta('meta[property="og:site_name"]', { property: 'og:site_name' });
    ogSite.setAttribute('content', siteName);

    const ogImage = ensureMeta('meta[property="og:image"]', { property: 'og:image' });
    ogImage.setAttribute('content', image);

    if (url) {
      const ogUrl = ensureMeta('meta[property="og:url"]', { property: 'og:url' });
      ogUrl.setAttribute('content', url);
    }

    // Twitter
    const twCard = ensureMeta('meta[name="twitter:card"]', { name: 'twitter:card' });
    twCard.setAttribute('content', 'summary_large_image');

    const twTitle = ensureMeta('meta[name="twitter:title"]', { name: 'twitter:title' });
    twTitle.setAttribute('content', title || document.title);

    const twDesc = ensureMeta('meta[name="twitter:description"]', { name: 'twitter:description' });
    twDesc.setAttribute('content', description || '');

    const twImage = ensureMeta('meta[name="twitter:image"]', { name: 'twitter:image' });
    twImage.setAttribute('content', image);

    // JSON-LD structured data
    if (structuredData) {
      let script = document.head.querySelector('script[data-seo-structured]');
      if (!script) {
        script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.setAttribute('data-seo-structured', 'true');
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(structuredData);
    }
  }, [title, description, url, image, type, siteName, structuredData]);

  return null;
};

export default Seo;
